import { render, staticRenderFns } from "./biaozhu.vue?vue&type=template&id=5cc967f8&"
import script from "./biaozhu.vue?vue&type=script&lang=ts&"
export * from "./biaozhu.vue?vue&type=script&lang=ts&"
import style0 from "./biaozhu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports